import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import { ThemeConsumer as ThemeConsumer$1 } from 'styled-components';
import noop from '@userzoomlibraries/toolkit-js-utils/noop';
import { jsx } from 'react/jsx-runtime';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

var ThemeConsumer = function ThemeConsumer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsx(ThemeConsumer$1, {
    children: children
  });
};

ThemeConsumer.COMPONENT_ID = 'Gearz.ThemeConsumer';
ThemeConsumer.displayName = ThemeConsumer.COMPONENT_ID;
ThemeConsumer.propTypes = {
  children: PropTypes.funcWithDescription('Content of the theme consumer.')
};
ThemeConsumer.defaultProps = {
  children: noop
};

export { ThemeConsumer as T };
